import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';

export const createStateSelector = ({ create }: DefaultRootState) => create;

export const createModeSelector = createSelector(
  createStateSelector,
  ({ createMode }) => createMode,
);

export const currentLeadsSelector = createSelector(
  createStateSelector,
  ({ currentLeads }) => currentLeads,
);
